module.exports = __webpack_public_path__ + "static/media/4-1@2x.4b48fc35.png";